import { cn } from '../../libs/utils';

import { BaseTopNavigationProps } from './type/BaseTopNavigationType';

export function BaseTopNavigation({ leftAction, rightAction, className, title, bg = false, bgColor, titleAction, ...props }: BaseTopNavigationProps) {
  return (
    <div
      className={cn(
        'z-top-navigation flex h-top-navigation items-center justify-center w-full',
        {
          'bg-neutral-background-main': bg
        },
        className
      )}
      style={{ backgroundColor: bgColor ? bgColor : '' }}
      {...props}
    >
      <div className={'container-padding-small container-xlarge relative flex w-full items-center justify-between'}>
        <div>{leftAction}</div>
        {title && (
          <div
            data-testid="topNavigationTitle"
            className={cn('body-large-semibold absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-neutral-foreground-main', {
              'cursor-pointer': titleAction
            })}
            onClick={() => {
              titleAction?.();
            }}
          >
            {title}
          </div>
        )}
        {rightAction}
      </div>
    </div>
  );
}
